import Component from 'flarum/common/Component';
import { formatDate } from '../utils/format';
import { mediaCredit } from '../utils/credit';
import { tt } from '../i18n';

/**
 * Schermvullende beeldviewer voor flyers en foto's.
 *
 * attrs: items [{src, caption, date, credit, credit_url}], index, base, onclose
 */
export default class Lightbox extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.index = this.attrs.index || 0;
    this.onkey = (e) => {
      if (e.key === 'Escape') this.attrs.onclose();
      else if (e.key === 'ArrowRight') this.go(1);
      else if (e.key === 'ArrowLeft') this.go(-1);
      else return;
      e.preventDefault();
      m.redraw();
    };
  }

  oncreate(vnode) {
    super.oncreate(vnode);
    document.addEventListener('keydown', this.onkey);
    document.body.classList.add('LcLightbox-open');
    this.element.focus();
  }

  onremove(vnode) {
    super.onremove(vnode);
    document.removeEventListener('keydown', this.onkey);
    document.body.classList.remove('LcLightbox-open');
  }

  go(step) {
    const n = this.attrs.items.length;
    this.index = (this.index + step + n) % n;
  }

  view() {
    const items = this.attrs.items;
    const item = items[this.index];
    const many = items.length > 1;

    return (
      <div
        className="LcLightbox"
        role="dialog"
        aria-modal="true"
        tabindex="-1"
        onclick={(e) => {
          if (e.target === this.element || e.target.classList.contains('LcLightbox-stage')) this.attrs.onclose();
        }}
      >
        <button className="LcLightbox-close" aria-label={tt('common.close')} onclick={() => this.attrs.onclose()}>
          <i className="fas fa-times" aria-hidden="true" />
        </button>
        {many ? (
          <button className="LcLightbox-nav LcLightbox-nav--prev" aria-label={tt('common.previous')} onclick={() => this.go(-1)}>
            <i className="fas fa-chevron-left" aria-hidden="true" />
          </button>
        ) : null}
        <figure className="LcLightbox-stage">
          <img src={this.attrs.base + item.src} alt={item.caption || ''} />
          <figcaption>
            {item.date ? <span className="LcLightbox-date">{formatDate(item.date)}</span> : null}
            {item.caption ? <span>{item.caption}</span> : null}
            {mediaCredit(item, 'LcLightbox-credit')}
            {many ? <span className="LcLightbox-count">{this.index + 1} / {items.length}</span> : null}
          </figcaption>
        </figure>
        {many ? (
          <button className="LcLightbox-nav LcLightbox-nav--next" aria-label={tt('common.next')} onclick={() => this.go(1)}>
            <i className="fas fa-chevron-right" aria-hidden="true" />
          </button>
        ) : null}
      </div>
    );
  }
}
